
import { Api } from '@evertel/api'
import { APIDataObject } from '@evertel/types'
import { decorate, inject, injectable } from 'inversify'


interface RegisterBody {
    email: string
    password: string
    firstName: string
    lastName: string
    deviceToken: string
}

class RegistrationController {

    constructor(
        private api: Api
    ) {}

    registerInAuth0 = async (body: RegisterBody): Promise<APIDataObject> => {
        return await this.api.Routes.Auth0.postSignup(body)
    }

}

// Dependency injection with Inversify
decorate(injectable(), RegistrationController)
decorate(inject(Api), RegistrationController, 0)

export { RegistrationController }
